// The app's strings for the shared i18next runtime (@todo/core/i18n/runtime):
// bundled, so translations resolve synchronously during the static render.

import { getInstanceForLocale, initI18n } from '@todo/core/i18n/runtime';

import de from './resources/de.json';
import en from './resources/en.json';
import ru from './resources/ru.json';

const i18n = initI18n({
  en: { translation: en },
  de: { translation: de },
  ru: { translation: ru },
});

export { getInstanceForLocale };
export default i18n;
